<div class="main-content">
  <div class="container-fluid">
    <mat-tab-group animationDuration="0ms">
      <mat-tab label="Telegram Outreach">
        <div class="card mt-3">
          <div class="card-header card-header-danger">
            <h4 class="card-title">SG Telegram Channel</h4>
            <p class="card-category">
              Posts recent products to the FishyHub Singapore Telegram channel — one message per
              product, with an image, price, a short description and a link to order.
            </p>
          </div>
          <div class="card-body">
            <fh-sg-telegram-panel></fh-sg-telegram-panel>
          </div>
        </div>
      </mat-tab>
      <mat-tab label="Email Outreach">
        <div class="card mt-3">
          <div class="card-header card-header-danger">
            <h4 class="card-title">Email Outreach</h4>
            <p class="card-category">
              Emails to segments of shoppers, by market - one email per person.
            </p>
          </div>
          <div class="card-body">
            <fh-email-outreach-panel></fh-email-outreach-panel>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
